// test477
(477 && 0);
